import { render, staticRenderFns } from "./_FaqList.vue?vue&type=template&id=3363ee68&scoped=true&"
import script from "./_FaqList.vue?vue&type=script&lang=js&"
export * from "./_FaqList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3363ee68",
  null
  
)

export default component.exports